import { Favorites } from '@/services';
import { SET } from '../';

export default {
    namespaced: true,
    state: {
        products: [],
        treatments: []
    },
    getters: {
        get(state) {
            return key => state[key];
        },
        getFavoriteProuct: (state) => (id) => {
            return state.products?.find(x => x.productId === id)
        },
        getFavoriteTreatment: (state) => (id) => {
            return state.treatments?.find(x => x.treatmentId === id)
        }
    },
    mutations: {
        SET,
    },
    actions: {
        async getFavoriteProducts({ commit, rootState }) {
            var activeSites = rootState.webshop.settings.activatedSalons.map(x => x.siteId)
            let response = await Favorites.GetFavoriteProducts(activeSites)
            commit('SET', {
                key: 'products',
                value: response
            })
        },
        async updateFavoriteProducts({ commit, rootState }, payload) {
            var activeSites = rootState.webshop.settings.activatedSalons.map(x => x.siteId)
            let response = await Favorites.UpdateFavoriteProducts(payload.product, activeSites)
            commit('SET', {
                key: 'products',
                value: response
            })
        },
        async getFavoriteTreatments({ commit, rootState }) {
            var activeSites = rootState.webshop.settings.activatedSalons.map(x => x.siteId)
            let response = await Favorites.GetFavoriteTreatments(activeSites)
            commit('SET', { 
                key: 'treatments',
                value: response
            })
        },

        $reset({ commit }) {
            commit('SET', {
                key: 'products',
                value: []
            })
            commit('SET', {
                key: 'treatments',
                value: []
            })
        }
    }
};
